<template>
  <router-view />
</template>

<script>
export default {
  name: "ParentWrapper"
}
</script>

<style scoped>

</style>
